<template>
  <sign-page
    title-text="入库管理"
    :request="request"
    :column-list="columnList"
    table-size="small"
    ref="inPage"
    :title-menus="[{key: 'add', label: '入库'}]"
    :table-actions="tableActions"
    @tableAction="tableAction"
    :form-parms-add="formParmsAdd"
    :form-parms-update="formParmsUpdate"
    :onFormChange="onFormChange"
    :table-actions-fixed="true"
    :need-data-file="true">
    <template v-slot:title>
      <div style="display: flex;align-items: center;margin-left: 20px;">
        <fm-switch size="small" v-model="isNotOut" @change="isNotOutChange">
          <span slot="on">存储中</span>
          <span slot="off">已出库</span>
        </fm-switch>
      </div>
    </template>
  </sign-page>
</template>

<script>
import {
  assetsInRequest as request
} from '../../api'

export default {
  computed: {
    tableActions () {
      let data = [{
        key: 'edit',
        label: '修改'
      },
      {
        key: 'del',
        label: '删除'
      }]
      return data
    },
    formParmsAdd: {
      get () {
        let data = [{
          type: 'select',
          label: '资产编码',
          key: 'assetsId',
          selectDatas: this.$store.getters.assetsList,
          check: {
            required: true
          }
        },
        {
          type: 'select',
          label: '入库机构',
          key: 'inOrgId',
          selectDatas: this.$store.getters.orgList,
          check: {
            required: true
          }
        },
        {
          type: 'datePicker',
          label: '入库日期',
          key: 'inTime',
          check: {
            required: true
          }
        }]
        return data
      }
    },
    formParmsIn: {
      get () {
        let data = [{
          type: 'select',
          label: '出库机构',
          key: 'outOrgId',
          selectDatas: this.$store.getters.orgList,
          check: {
            required: true
          }
        },
        {
          type: 'datePicker',
          label: '出库日期',
          key: 'outTime',
          check: {
            required: true
          }
        }]
        return data
      }
    },
    formParmsUpdate: {
      get () {
        return [{
          type: 'select',
          label: '资产编码',
          key: 'assetsId',
          selectDatas: this.$store.getters.assetsList,
          check: {
            required: true
          }
        },
        {
          type: 'select',
          label: '入库机构',
          key: 'inOrgId',
          selectDatas: this.$store.getters.orgList,
          check: {
            required: true
          }
        },
        {
          type: 'datePicker',
          label: '入库日期',
          key: 'inTime',
          check: {
            required: true
          }
        },
        {
          type: 'select',
          label: '存储状态',
          selectDatas: [{key: 'in', label: '存储中'}, {key: 'out', label: '已出库'}],
          key: 'ccStatus',
          check: {
            required: true
          }
        },
        {
          type: 'select',
          label: '出库机构',
          key: 'outOrgId',
          selectDatas: this.$store.getters.orgList,
          check: {
            required: true
          },
          show: (formData) => {
            return formData.ccStatus === 'out'
          }
        },
        {
          type: 'datePicker',
          label: '出库日期',
          key: 'outTime',
          check: {
            required: true
          },
          show: (formData) => {
            return formData.ccStatus === 'out'
          }
        }]
      }
    },
    columnList: {
      get () {
        let data = [{
          title: '库存记录编号',
          field: 'code',
          width: '130',
          sort: true
        },
        {
          title: '资产编号',
          field: 'assetsCode',
          sort: true
        },
        {
          title: '资产名称',
          field: 'assetsName',
          sort: true
        },
        {
          title: '规格型号',
          field: 'assetsGgxh',
          sort: true
        },
        {
          title: '价值',
          dataType: Number,
          field: 'assetsJz',
          sort: true
        },
        {
          title: '入库机构',
          field: 'inOrgName',
          sort: true
        },
        {
          title: '入库日期',
          field: 'inTime',
          dataType: Date,
          sort: true,
          render: (h, rowData) => {
            return h('div', rowData && rowData.inTime ? rowData.inTime.slice(0, 10) : '-')
          }
        },
        {
          title: '出库机构',
          field: 'outOrgName',
          sort: true
        },
        {
          title: '出库日期',
          field: 'outTime',
          dataType: Date,
          sort: true,
          render: (h, rowData) => {
            return h('div', rowData && rowData.outTime ? rowData.outTime.slice(0, 10) : '-')
          }
        },
        {
          title: '状态',
          field: 'status',
          sort: true
        }]
        return data
      }
    }
  },
  created () {
    if (this.$authFunsProxy.edit || this.$authFunsProxy.add) {
      this.$store.dispatch('loadOrgList')
      this.$store.dispatch('loadAssetsList')
    }
  },
  methods: {
    isNotOutChange () {
      this.$refs.inPage.loadData()
    },
    onFormChange (key, value) {
      if (key === 'ccStatus' && value === 'in') {
        return {
          outTime: null,
          outOrgId: null
        }
      }
    },
    tableAction () {
      this.$refs.inPage.formParms = this.formParmsIn
      this.$refs.inPage.openDialog = true
    },
    async loadData () {
      let parm = {}
      if (this.isNotOut) {
        parm.notOut = 1
      } else {
        parm.isOut = 1
      }
      let data = await request.get(parm)
      data.forEach(v => {
        v.status = v.outTime ? '已出库' : '存储中'
        v.ccStatus = v.outTime ? 'out' : 'in'
      })
      return data
    }
  },
  data () {
    return {
      request: Object.assign({}, request, {
        get: this.loadData
      }),
      isNotOut: true,
      pageVm: null
    }
  }
}
</script>

<style lang="less" scoped>
.img-c {
  height: 60vh;
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  .no-img {
    font-size: 1.4rem;
    color: #999;
  }
  img {
    max-height: 100%;
    max-width: 100%;
  }
}
.file-d-footer {
  display: flex;
  justify-content: center;
  align-items: center;
}
.file-d-footer-wx {
  display: none;
  justify-content: center;
  align-items: center;
}
</style>